/* eslint-disable no-redeclare */
import { z } from 'zod';

export const QualifyingLifeEvent = z.enum([
  'Coverage',
  'LostCoverage',
  'Marriage',
  'Divorce',
  'Baby',
  'Moved',
  'LostDependentStatus',
  'IncomeChanged',
  'ShortTerm',
  'ChangeImmigrationStatus',
  'Other',
  'None',
]);

export type QualifyingLifeEvent = z.infer<typeof QualifyingLifeEvent>;
